import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { ApplicationVersion } from '@flowx/designer/shared/entities/application.entity'
import {
  VersionActionConfig,
  VersionActionEvent,
  VersionActionType,
  VersionActionsMap,
} from '@flowx/designer/shared/versioning/version-actions.constants'

// The subset of the actions map this panel renders — merge/archive/unarchive belong to
// branch-info; edit-commit-message and export belong to version-info
const PANEL_ACTIONS: VersionActionType[] = [
  VersionActionType.ContinueMerge,
  VersionActionType.DiscardMerge,
  VersionActionType.CommitChanges,
  VersionActionType.CreateBuild,
  VersionActionType.StartNewVersion,
  VersionActionType.CreateNewBranch,
  VersionActionType.DiscardChanges,
]

@Component({
  selector: 'flx-version-actions',
  templateUrl: './version-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TooltipModule, FlxButtonModule, FlxIconModule],
})
export class VersionActionsComponent {
  actions = input.required<VersionActionsMap>()
  applicationVersion = input.required<ApplicationVersion>()
  actionTriggered = output<VersionActionEvent>()

  orderedActions = computed(() =>
    PANEL_ACTIONS.map((action) => this.actions()[action])
      .filter((config) => config.visible)
      .sort((a, b) => a.order - b.order)
  )

  onAction(config: VersionActionConfig): void {
    this.actionTriggered.emit({ action: config.action } as VersionActionEvent)
  }
}
